module.exports = __webpack_public_path__ + "static/oracle-3e72f560a4e516c9fcca63c5e02cbe4b.png";